import script from "./GuideSectionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideSectionButton.vue?vue&type=script&setup=true&lang=ts"

import "./GuideSectionButton.vue?vue&type=style&index=0&id=71ee2892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ee2892"]])

export default __exports__